const UTMIFY_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'

/**
 * Injects the official UTMify UTM tracking script once per page load.
 */
export function loadUtmify(): void {
  if (typeof document === 'undefined') return
  if (document.querySelector(`script[src="${UTMIFY_SRC}"]`)) return

  const script = document.createElement('script')
  script.src = UTMIFY_SRC
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subids', '')
  document.head.appendChild(script)
}
